import { Component } from "react";
import styled from "styled-components";
import { scrollIntoView } from "../../../lib/util";

const ErrorMarker = styled.div`
  position: relative;
  transform: translateY(-150px);
`;

export class ScrollToError extends Component<{}> {
  componentDidMount() {
    this.scroll();
  }

  componentDidUpdate() {
    this.scroll();
  }

  scroll() {
    const errorElement = document.querySelector(`${ErrorMarker}`);
    if (errorElement) scrollIntoView(errorElement);
  }

  render() {
    return null;
  }
}

export default ErrorMarker;
